import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FormArray, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-sessions-step',
  templateUrl: './sessions-step.component.html',
  styleUrls: ['../event-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SessionsStepComponent {
  eventForm: InputSignal<UntypedFormGroup> = input.required();
  isEventLocked: InputSignal<boolean> = input.required();

  addSessionEvent: OutputEmitterRef<void> = output();
  removeSessionEvent: OutputEmitterRef<number> = output();

  get sessions() {
    return this.eventForm().get('sessions') as FormArray;
  }

  addSession() {
    this.addSessionEvent.emit();
  }

  removeSession(index: number) {
    this.removeSessionEvent.emit(index);
  }
}
